import { Component, ComponentChildren, h } from 'preact'
import Sorting from '../table/Sorting'
import classNames from 'classnames'
import { Model, Sort } from '../table/types'
import { subscribe } from '../../utils/globals'

export const defaultCellSize = 'm'

type Props = {
  model?: Model[],
  children?: ComponentChildren,
  sort?: Sort,
  narrow?: boolean,
  classes?: string[],
  style?: { [key: string]: any },
  staticWidth?: boolean,
  actionElements?: JSX.Element,
}

type State = {
  isMenuOpen: boolean
}

class EmptyTable extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      isMenuOpen: true
    }
  }

  componentDidMount () {
    subscribe('control_sidebar_state', (payload) => this.setState({ isMenuOpen: payload.isOpen }))
  }

  render ({
    model,
    children,
    sort,
    narrow,
    classes = [],
    style = {},
    staticWidth = false,
    actionElements
  }: Props, { isMenuOpen }: State) {
    const useObjectModel = model && model[0].hasOwnProperty('header')
    return <div class='control-table'>
      {actionElements && <div className='action-bar-wrapper'>
        <div class='action-bar'>
          {actionElements}
        </div>
      </div>}
      <div class={classNames('table-wrapper')}
        style={staticWidth ? 'transition: none' : { width: `calc(100vw - ${isMenuOpen ? '376' : '152'}px)` }}>
        <table className={classNames({
          'narrow': narrow
        }, ...classes)} style={style}>
          <thead>
            <tr>
              {
                model && Object.keys(model).map((key: any) => {
                  if (model[key].isHidden) {
                    return
                  }
                  return (<th className={`${model[key].size || defaultCellSize}`}>
                    {!model[key].hasOwnProperty('sorting') &&
                      <div className={`table-header-cell-${model[key].accessor}`}>
                        {useObjectModel ? model[key].header : model[key]}
                      </div>}
                    {model[key].hasOwnProperty('sorting') &&
                      <div className={`table-header-cell-${model[key].accessor} sortable`}>
                        {useObjectModel ? model[key].header : model[key]}
                        <Sorting
                          direction={sort?.direction}
                          isEnabled={sort?.order === model[key].sorting}
                        />
                      </div>}
                  </th>)
                })
              }
            </tr>
          </thead>
        </table>
        {children}

      </div>
    </div>
  }
}

export default EmptyTable
